import Auth from '../auth/Authenticator';
import { confirmPopup } from 'primereact/confirmpopup';
import Cookies from 'js-cookie';
import { ArrendamentoType, GroupType, ImovelType, LoteType, PermissionType, PessoaType, PlanoType, PlantioLoteType, PlantioType, PropriedadeSearchType, PropriedadesResumoType, STATUS, UserType } from '../db/Orm';
import axios, { AxiosError } from 'axios';
import * as messages from '../utils/messages';

export const API_URL = "https://api.monitorabahia.gearspark.com.br/api/";
//export const API_URL = "https://monitorabahia.adab.ba.gov.br/api/";

type ProcessingMethod = 'rl'|'rn' // Regressão Linear ou Rede Neural

// Função auxiliar para obter o token CSRF do cookie
const getCsrfToken = (): string => {
    let cookieValue = '';
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, 10) === 'csrftoken=') {
                cookieValue = decodeURIComponent(cookie.substring(10));
                console.log('CSRF Token obtido:', cookieValue);
                break;
            }
        }
    }
    return cookieValue;
};


const getAuthHeaders = () => {
    return { headers: { Authorization: 'Bearer ' + Cookies.get('token') } };
};

const requestOptions = (metodo: string, data?: FormData): RequestInit => {
    if (data)
        return {
            method: metodo,
            mode: 'cors',
            headers: Auth.getHeader(),
            body: data
        };
    return {
        method: metodo,
        mode: 'cors',
        headers: Auth.getHeader()
    };
};

const getConfig = () => {
    return {
        method: "GET",
        headers: Auth.getHeader()
    };
};

const deleteConfig = () => {
    return {
        method: "DELETE",
        headers: Auth.getHeader()
    };
};

const getHeaders = (token: string) => {
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + token);
    return headers;
};

const getData = async (url: string, navigate: any, onError: Function) => {
    try {
        const response = await fetch(url, requestOptions('GET')) as Response;
        if (response.ok) {
            return await response.json();
        } else {
            console.log('Response not ok:', response.status, response.statusText);
            onError(response);
            Auth.signout(() => navigate('/', { state: true }));
        }
    } catch (e) {
        onError(e);
        Cookies.remove('user');
        Cookies.remove('token');
        navigate&&navigate('/');
    }
    return null;
};

const getPessoas = async (navigate: any, onError: Function, status?: STATUS) => {
    const data: Array<PessoaType> = [];
    let url = API_URL + 'pessoas/';
    if (status !== undefined) url += '?status=' + status;
    const response = await getData(url, navigate, onError);
    if (response !== null) response.forEach((d: PessoaType) => data.push(d));
    return data;
};

const getPessoasExploded = async (navigate: any, onError: Function, status?: STATUS) => {
    let url = API_URL + 'pessoas/';
    if (status !== undefined) url += '?status=' + status;
    const data: Array<PessoaType> = [];
    const response = await getData(url, navigate, onError);
    if (response !== null) response.forEach((d: PessoaType) => data.push(d));
    return data;
};

const cpfExists = async (cpf: string) => {
    try {
        const formData = new FormData();
        formData.append("username", cpf.replaceAll('.', '').replaceAll('-', '').replaceAll('/', ''));
        const response = await fetch(API_URL + 'user-exists/', { method: 'POST', body: formData });
        const exists = await response.json();
        return exists.user_exists;
    } catch (e) {
        console.log(e);
    }
};

const getUser = async (cpf: string, navigate: any, onError: Function) => {
    const url = API_URL + 'users/?username=' + cpf;
    return await getData(url, navigate, onError);
};

const getPessoaExplodedByUser = async (user: string, navigate: any, onError: Function) => {
    const url = API_URL + 'pessoas/?user=' + user;
    return await getData(url, navigate, onError);
};

const getPessoaExplodedByCPFCNPJ = async (cpf_cnpj: string, navigate: any, onError: Function) => {
    const url = API_URL + 'pessoas/?cpf_cnpj=' + cpf_cnpj + '&nova_pessoa=null';
    return await getData(url, navigate, onError);
};

const newHistory = async () => {
    const response = await fetch(API_URL + 'history/', {
        method: "POST",
        mode: 'cors',
        headers: Auth.getHeader(),
        body: JSON.stringify({
            action: "1",
            user: "1",
        }),
    });
    const data: History = await response.json();
    return data;
};

const removePessoa = async (pessoa: PessoaType, posFunction?: Function) => {
    await fetch(API_URL + 'pessoas/' + pessoa.id, {
        method: "DELETE",
        mode: 'cors',
        headers: Auth.getHeader()
    });
    posFunction && posFunction();
};

const resetarSenha = async (pessoa: PessoaType, posFunction?: Function) => {
    await fetch(API_URL + 'pessoas/' + pessoa.id + '/resetar/', {
        method: "POST",
        mode: 'cors',
        headers: Auth.getHeader()
    });
    posFunction && posFunction();
};

const RemoveFarm = (event: any, farm: ImovelType, navigator?: any) => {
    const remove = async () => {
        await fetch(API_URL + 'farms/' + farm.id, {
            method: "DELETE",
            mode: 'cors',
            headers: Auth.getHeader()
        });
        console.log('Removido fazenda (' + farm.id + '): ' + farm.nome);
        console.log('Dono', farm.proprietario);
        alert('Propriedade ' + farm.nome + ' do proprietário ' + farm.proprietario.nome_razao + ' removida com sucesso!');
        navigator && navigator("/home");
    };
    const accept = () => {
        alert('ok');
    };
    confirmPopup({
        target: event.currentTarget,
        message: 'Do you want to delete this record?',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        accept: accept
    });
    const resposta = window.confirm('Você tem certeza que deseja remover a fazenda ' + farm.nome + '?');
    if (resposta) remove();
};

const removePropriedade = async (propriedade: any, toast: any, posFunction?: Function) => {    
    const response = await fetch(`${API_URL}propriedades/${propriedade.id}/` , {
        method: "DELETE",
        mode: 'cors',
        headers: Auth.getHeader()
    });
    
    if (!response.ok) {
        if (response.status === 403) {
            toast?.show({
                severity: 'error',
                summary: 'Permissão Negada',
                detail: 'Você não possui permissão para remover esta propriedade.',
                life: 3000
            });
        } else {
            toast?.show({
                severity: 'error',
                summary: 'Erro ao Remover',
                detail: `Erro ao remover propriedade (Código: ${response.status})`,
                life: 3000
            });
        }
        return;
    }
    
    console.log('Removido fazenda (' + propriedade.id + '): ' + propriedade.nome);
    console.log('Dono', propriedade.proprietario);
    toast?.show({
        severity: 'success',
        summary: 'Sucesso',
        detail: `Propriedade ${propriedade.nome} do proprietário ${propriedade.proprietario.nome_razao} removida com sucesso!`,
        life: 3000
    });
    posFunction && posFunction();
};

const getPropriedades = async (navigate: any, onError: Function, municipio?: any, proprietario?: any, status?: STATUS) => {
    let url = API_URL + 'propriedades/';
    if (municipio || proprietario || status) url += '?';
    if (municipio) url += '&municipio=' + municipio.id;
    if (proprietario) url += '&proprietario=' + proprietario.id;
    if (status) url += '&status=' + status;
    const data:ImovelType[]|null = await getData(url, navigate, onError);
    if (!data) return ([] as ImovelType[]);
    return data;
};

const getPropriedadesSearch = async (navigate: any, onError: Function, municipio?: any, proprietario?: any, status?: STATUS) => {
    let url = API_URL + 'propriedades/list_search/';
    if (municipio || proprietario || status) url += '?';
    if (municipio) url += '&municipio=' + municipio.id;
    if (proprietario) url += '&proprietario=' + proprietario.id;
    if (status) url += '&status=' + status;
    const data:PropriedadeSearchType[]|null = await getData(url, navigate, onError);
    if (!data) return ([] as PropriedadeSearchType[]);
    return data;
};

const getPropriedadesResumo = async (navigate: any, onError: Function) => {
    const data:PropriedadesResumoType|null = await getData(API_URL + 'propriedades/resumo/', navigate, onError);
    if (!data) return {
        propriedades_numero: 0,
        lotes_numero: 0,
        area_total: 0,
        area_cultivada: 0
    } as PropriedadesResumoType;
    return data;
};

const getPlanos = async (navigate: any, onError: Function) => {
    let url = API_URL + 'planos/';
    const data = await getData(url, navigate, onError);
    return data;
};

const getMunicipios = async (uf: string) => {
    try {
        const response = await fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + uf + '/municipios', requestOptions('GET'));
        if (response.ok) {
            return response.json();
        } else console.log(response);
    } catch (e) { console.log(e); }
    return null;
};

const getMapas = async (uf: string) => {
    try {
        const response = await fetch('https://servicodados.ibge.gov.br/api/v3/malhas/estados/' + uf + '?intrarregiao=municipio&formato=application/vnd.geo+json');
        const data = await response.json();
        return data.features;
    } catch (e) {
        console.log(e);
    }
    return null;
};

const loadingIbgeData = async (posFunction?: Function) => {
    const ms: Array<any> = [];
    try {
        const municipios = await getMunicipios('BA');
        const mapas = await getMapas('BA');
        Cookies.set('mapas', JSON.stringify(mapas)); // Cookies store strings
        municipios.map((municipio: any) => {
            ms.push({
                ...municipio,
                mapa: {
                    "type": "FeatureCollection",
                    "features": [
                        mapas.filter((mapa: any) => mapa.properties.codarea == municipio.id)[0]
                    ]
                }
            });
        });
    } catch (e) {
        console.log(e);
    }
    posFunction && posFunction(ms);
    return ms;
};

const getIbgeData = async (uf: string = 'BA') => {
    const ms: Array<any> = [];
    try {
        const municipios = await getMunicipios(uf);
        const mapas = await getMapas(uf);
        municipios.map((municipio: any) => {
            ms.push({
                ...municipio,
                mapa: {
                    "type": "FeatureCollection",
                    "features": [
                        mapas.filter((mapa: any) => mapa.properties.codarea == municipio.id)[0]
                    ]
                }
            });
        });
    } catch (e) {
        console.log(e);
    }
    return ms;
};

const solicitarResetSenha = async (data: { cpf: string, email?: string, celular?: string }) => {
    return await axios.post(API_URL + 'solicitar-reset-senha/', data);
};

const cadastrarPlano = async (plano: PlanoType) => {
    const formData = new FormData();
    formData.append('safra_id', String(plano.safra));
    formData.append('propriedade_id', String(plano.propriedade.id));
    if (plano.responsavel_tecnico)
        formData.append('responsavel_tecnico_id', String(plano.responsavel_tecnico.id));
    if (plano.drt)
        formData.append('drt', String(plano.drt));
    if (plano.doc_drt)
        formData.append('doc_drt', plano.doc_drt);
    try {
        const requestOptions = { method: 'POST', headers: Auth.getHeader(true), body: formData };
        const response = await fetch(API_URL + 'planos/', requestOptions);
        if (response.ok)
            return await response.json();
        else {
            const data = await response.json();
            console.error('Erro ao cadastrar plano:', data);
            return null;
        }
    } catch (error: any) {
        console.error('Erro na data:', error);
    }
    return null;
};

const cadastrarPlanoCompleto = async (plano: PlanoType, plantios: PlantioType[]) => {
    const planoData = {
        responsavel_tecnico_id: plano.responsavel_tecnico.id,
        propriedade_id: plano.propriedade.id,
        safra_id: 1,
    }
    const plantiosData = plantios.map((plantio) => ({
        data: plantio.data? plantio.data.toISOString().split('T')[0] : null,
        cultura: plantio.cultura,
        variedade: plantio.variedade,
        produtividade: plantio.produtividade,
        irrigacao_fluvial: plantio.irrigacao_fluvial,
        irrigacao_poco: plantio.irrigacao_poco,
        lotes: plantio.lotes?.map((lote) => lote.id) || []
    }));
    try {
        const requestOptions = { method: 'POST', headers: Auth.getHeader(false), body: JSON.stringify({ plano: planoData, plantios: plantiosData })};
        const response = await fetch(API_URL + 'planos/cadastrar/', requestOptions);
        console.log('Response:', response);
        if (response.ok) {
            return await response.json();
        } else {
            const data = await response.json();
            if (!data.detail){
                data.detail = JSON.stringify(data);
            }
            data.ok = false
            console.error('Erro ao cadastrar plano completo:', data);
            return data;
        }
    }
    catch (error: any) {
        console.error('Erro nos dados:', error);
    }
}

const cadastrarPlantio = async (plantio: PlantioType) => {
    if (!plantio.data) return null;
    const formData = new FormData();
    formData.append('data', String(plantio.data.getFullYear() + '-' + (plantio.data.getMonth() + 1) + '-' + (plantio.data.getDate()) || ''));
    formData.append('cultura', String(plantio.cultura || ''));
    formData.append('variedade', String(plantio.variedade || ''));
    formData.append('produtividade', String(plantio.produtividade || ''));
    formData.append('irrigacao_fluvial', String(plantio.irrigacao_fluvial || ''));
    formData.append('irrigacao_poco', String(plantio.irrigacao_poco || ''));
    if (plantio.plano?.id)
        formData.append('plano', plantio.plano.id.toString());
    const requestOptions = { method: 'POST', headers: Auth.getHeader(true), body: formData, };
    try {
        const response = await fetch(API_URL + 'plantios/', requestOptions);
        if (!response.ok) {
            console.log('Erro ao cadastrar plantio:', await response.json());
            return null;
        }
        const data = await response.json();
        return data;
    } catch (error: any) {
        console.error('Erro na data:', error);
    }
    throw new Error('Erro no Cadastro de Plantio');
};

const cadastrarPlantioLote = async (plantio: PlantioType, lotes: Array<LoteType>) => {
    const plantioLotes: Array<PlantioLoteType> = [];
    if (!plantio.id) return null;
    const promisses = lotes.map(async (lote) => {
        const formData = new FormData();
        formData.append('lote_id', String(lote.id || ''));
        formData.append('plantio', String(plantio.id || ''));
        const requestOptions = { method: 'POST', headers: Auth.getHeader(true), body: formData };
        try {
            const data: any = await fetch(API_URL + 'plantiolote/', requestOptions);
            return plantioLotes.push(data);
        } catch (error: any) {
            console.error('Erro na data:', error);
        } throw new Error('Erro no Cadastro de Plantio');
    });
    await Promise.all(promisses);
    return plantioLotes;
};

const getArrendamentos = async () => {
    return (await axios.get(API_URL + 'arrendamentos/', getAuthHeaders())).data as Array<ArrendamentoType>;
};

const finalizarArrendamento = async (id: number) => {
    return (await axios.post(API_URL + 'arrendamentos/' + id + '/finalizar_arrendamento/', undefined, getAuthHeaders())).data;
};

const avaliarArrendamento = async (id: number, status: STATUS) => {
    switch (status) {
        case STATUS.APROVADO:
            return (await axios.post(API_URL + 'arrendamentos/' + id + '/avaliar_arrendamento/?set_status=aprovado', undefined, getAuthHeaders())).data;
        case STATUS.REPROVADO:
            return (await axios.post(API_URL + 'arrendamentos/' + id + '/avaliar_arrendamento/?set_status=rejeitado', undefined, getAuthHeaders())).data;
        default:
            return (await axios.post(API_URL + 'lotes/' + id + '/avaliar_arrendamento/?set_status=novo', undefined, getAuthHeaders())).data;
    }
};

const aprovarRT = async (pessoaId: string) => {
    return (await axios.post(API_URL + 'pessoas/' + pessoaId + '/aprovar-rt/', {}, getAuthHeaders())).data;
};

const reprovarRT = async (pessoaId: string) => {
    return (await axios.post(API_URL + 'pessoas/' + pessoaId + '/reprovar-rt/', {}, getAuthHeaders())).data;
};

//PERMISSÕES E GROUPOS
const getGrupos = async () => {
    return (await axios.get(API_URL + 'groups/', getAuthHeaders())).data as GroupType[];
};

const getGroupPerms = async (group: GroupType) => {
    console.log('Get Group Perms', group, getAuthHeaders());
    return (await axios.get(`${API_URL}groups/${group.id}/view_permissions/`, getAuthHeaders())).data as PermissionType[];
};

const getUserPerms = async (user: UserType) => {
    const userPerms = new Map<string, PermissionType>();
    for (const g of user.groups) {
        const perms = await getGroupPerms(g);
        perms.map(v => userPerms.set(v.string_perm, v));
    }
    return userPerms;
};

const getAllPerms = async () => {
    const data = (await axios.get(`${API_URL}permissions/`, getAuthHeaders())).data as PermissionType[];
    return data;
};

const reducePermsToUrl = (perms: PermissionType[]) => {
    const mapped = new Map<string, string>();
    perms.forEach((v) => {
        const [content, strPerm] = v.string_perm.split('.');
        if (!mapped.has(content)) {
            mapped.set(content, strPerm);
            return;
        }
        mapped.set(content, (mapped.get(content) || '') + ',' + strPerm);
    });
    let url = '';
    mapped.forEach((v, k) => { url += `${k}=${v}&`; });
    return url.slice(0, -1);
};

const addGroupPerms = async (group: GroupType, perms: PermissionType[]) => {
    const url = `${API_URL}groups/${group.id}/add_permissions/?${reducePermsToUrl(perms)}`;
    return (await axios.post(url, undefined, getAuthHeaders())).data as PermissionType[];
};

const removeGroupPerms = async (group: GroupType, perms: PermissionType[]) => {
    const url = `${API_URL}groups/${group.id}/remove_permissions/?${reducePermsToUrl(perms)}`;
    return (await axios.post(url, undefined, getAuthHeaders())).data as PermissionType[];
};

const updateUserGroups = async (userId: number, groupIds: number[]) => {
    return (await axios.post(`${API_URL}users/${userId}/update-groups/`, { group_ids: groupIds }, getAuthHeaders())).data;
};

//PROCESSAMENTOS
const processarSojaPropriedade = async (id: number, inicio: Date, final: Date, metodo: ProcessingMethod) => {
    let error;
    const inicioISO = inicio.toISOString().split('T')[0];
    const finalISO = final.toISOString().split('T')[0];
    try {
        return (await axios.post(API_URL + 'propriedades/' + id + '/processar_poligono_period' + (metodo==='rn'?'_rf':'') + '/?start=' + inicioISO + '&end=' + finalISO,
            null, { ...getAuthHeaders(), responseType: 'blob' }));
    } catch (e) {
        error = e as AxiosError;
    }
    return error;
};

//PROCESSAMENTOS
const processarAlgodaoPropriedade = async (id: number, inicio: Date, final: Date, metodo: ProcessingMethod) => {
    let error;
    const inicioISO = inicio.toISOString().split('T')[0];
    const finalISO = final.toISOString().split('T')[0];
    try {
        return (await axios.post(API_URL + 'propriedades/' + id + '/processar_algodao_lotes_period' + (metodo==='rn'?'_rf':'') + '/?start=' + inicioISO + '&end=' + finalISO,
            null, { ...getAuthHeaders(), responseType: 'blob' }));
    } catch (e) {
        error = e as AxiosError;
    }
    return error;
};

const downloadFile = async (response: any, toastInstance: any) => {
    if (response !== null) {
        const blob = response.data;
        let filename = `relatorio_fallback.pdf`;
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^'";]+)['"]?/i);
            if (filenameMatch && filenameMatch[1]) {
                let extractedName = filenameMatch[1];
                try {
                    extractedName = decodeURIComponent(extractedName.replace(/UTF-8''/i, ''));
                } catch (e) {
                    console.warn("Falha ao decodificar o nome do arquivo URI-encoded:", extractedName, e);
                }
                filename = extractedName;
            } else {
                console.warn('Não foi possível extrair o nome do arquivo do Content-Disposition. Usando fallback.');
            }
        } else {
            console.warn('Cabeçalho Content-Disposition não encontrado. Usando fallback.');
        }
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        if (toastInstance && typeof toastInstance.show === 'function') {
            toastInstance.show({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Download de '${filename}' iniciado.`,
                life: 4000
            });
        } else {
            console.warn("Instância do Toast não disponível em downloadFile. O download prosseguiu sem notificação por toast.");
            alert(`Download de '${filename}' iniciado.`);
        }
    } else {
        console.error('A resposta recebida para download é nula.');
        if (toastInstance && typeof toastInstance.show === 'function') {
            toastInstance.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Falha ao iniciar o download: resposta nula.',
                life: 4000
            });
        } else {
            alert('Falha ao iniciar o download: resposta nula.');
        }
    }
};

const report = async (url: string) => {
    const authConfig = getAuthHeaders();
    const config = {
        ...authConfig,
        responseType: 'blob' as 'blob'
    };
    const response = await axios.get(API_URL + url + '/', config);
    return response;
};

const resetarSenhaConfirmar = (pessoa: PessoaType, toast: any) => {
    const mensagemSucesso = () => {
        console.log(`Reset de senha de (${pessoa.id}): ${pessoa.nome_razao}`);
        messages.message(toast, 'Reset de senha de ' + pessoa.nome_razao + ' realizado com sucesso!');
    };
    messages.confirmacao(toast, "Confirma o reset de senha de " + pessoa.nome_razao + "?", 'warn', () => { resetarSenha(pessoa, mensagemSucesso); });
};

const resetSenhaConfirmar = (pessoa: PessoaType, toast: any, callback?: (success: boolean) => void) => {
    const mensagemSucesso = (success: boolean, mensagem?: string) => {
        if (success) {
            console.log(`Reset de senha`);
            callback && callback(true);
        } else {
            console.error(`Erro ao resetar senha`);
            messages.message(toast, `Erro ao resetar senha, tente novamente.\n\nMensagem de erro:\n${mensagem}`, 'error');
            callback && callback(false);
        }
    };
    messages.confirmacao(toast, "Confirma o reset de senha?", 'warn', () => { resetSenha(pessoa, mensagemSucesso); });
};

const resetSenha = async (pessoa: PessoaType, posFunction?: Function) => {
    try {
        const response = await fetch(API_URL + 'solicitar-reset-senha/', {
            method: "POST",
            mode: 'cors',
            headers: Auth.getHeader(),
            body: JSON.stringify({
                cpf_cnpj: pessoa.cpf_cnpj,
                email: pessoa.email || null,
                celular: pessoa.celular || null
            })
        });
        if (response.ok) {
            posFunction && posFunction(true);
        } else {
            console.error('Erro ao resetar senha:', response.status);
            posFunction && posFunction(false, (await response.json()).detail || 'Erro desconhecido');
        }
    } catch (error) {
        console.error('Erro ao resetar senha:', error);
    }
};
const getSafras = async () => {
    try {
        return (await (axios.get(`${API_URL}safra/`, getAuthHeaders()))).data
    } catch (e) {
        console.error(e)
        return []
    }
}

const criarPlano = async (propriedade_id: number, safra_id: number) => {
    try {
        const response = await axios.post(`${API_URL}planos/`, {
            propriedade_id,
            safra_id
        }, getAuthHeaders());
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            console.log(error.response.data);
        }
        console.error('Error creating plano:', error);
        throw error;
    }
};
const cadastrarRT = async (pessoa: PessoaType, numeroRegistro: string, conselho: string, ufConselho: string, carteiraHabilitacao: File)=>{
    try {
        const formData = new FormData();
        if (!pessoa.id){
            console.error('Dados insuficientes para o cadastro de RT')
            return Error('Dados insuficientes para o cadastro de RT')
        }
        formData.append('registro_rt', numeroRegistro);
        formData.append('conselho_rt', conselho);
        formData.append('conselho_uf', ufConselho);
        formData.append('doc_rt', carteiraHabilitacao);
        formData.append('status_rt', STATUS.NOVO)
        const response = await axios.patch(`${API_URL}pessoas/${pessoa.id}/`, formData, getAuthHeaders())
        return response.data as PessoaType
    } catch (error) {
        if (error instanceof AxiosError){
            console.error(error)
            console.log(error.toJSON())
            return error
        }
        console.error(error)
        return Error('Ocorreu um erro desconhecido no cadastro de RT')
    }
}

const API = {
    url: API_URL,
    getConfig,
    deleteConfig,
    getData,
    getPessoas,
    getPessoasExploded,
    cpfExists,
    getUser,
    getPessoaExplodedByUser,
    getPessoaExplodedByCPFCNPJ,
    newHistory,
    removePessoa,
    resetarSenha,
    RemoveFarm,
    removePropriedade,
    requestOptions,
    getHeaders,
    getPropriedades,
    getPropriedadesSearch,
    getPropriedadesResumo,
    getPlanos,
    getMunicipios,
    getMapas,
    loadingIbgeData,
    getIbgeData,
    solicitarResetSenha,
    cadastrarPlano,
    cadastrarPlanoCompleto,
    cadastrarPlantio,
    cadastrarPlantioLote,
    getAuthHeaders,
    getArrendamentos,
    finalizarArrendamento,
    avaliarArrendamento,
    aprovarRT,
    reprovarRT,
    getGrupos,
    getGroupPerms,
    getUserPerms,
    getAllPerms,
    reducePermsToUrl,
    addGroupPerms,
    removeGroupPerms,
    updateUserGroups,
    processarSojaPropriedade,
    downloadFile,
    report,
    resetarSenhaConfirmar,
    resetSenhaConfirmar,
    resetSenha,
    cadastrarRT,
    getSafras,
    criarPlano,
    processarAlgodaoPropriedade
};

export default API;
